<template>
  <div class="login-card-container">
    <div class="login-tip">
      <div class="user">
        <div class="avatar">
          <img src="../../../assets/images/homePage/logged.png" alt="" />
        </div>
      </div>
      <div class="operation">
        <div class="hello">
          您好！欢迎来到智筑通
        </div>
        <div class="b-operation">
          <div class="custom-btn login-btn" @click="handleLogin">
            登录
          </div>
          <div class="custom-btn register" @click="handleRegister">
            注册
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleLogin() {
      this.$store.dispatch('login/login')
    },
    handleRegister() {
      this.$store.dispatch('login/login')
    }
  }
}
</script>

<style lang="scss">
.login-card-container {
  .login-tip {
    height: 90px;
    background: #ffffff;
    background-image: url('../imgs/card-bg.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    .user {
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      color: #333333;

      .avatar {
        width: 40px;
        height: 40px;
        margin: 0 16px 0 16px;
        img {
          width: 100%;
          height: auto;
        }
      }
    }
    .operation {
      height: 46px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .hello {
        font-size: 12px;
        line-height: 12px;
        color: #333333;
      }
      .b-operation {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .custom-btn {
          width: 60px;
          height: 20px;
          line-height: 18px;
          border-radius: 5px;
          font-size: 11px;
          text-align: center;
          cursor: pointer;
          border-radius: 10px;
        }
        .login-btn {
          color: #ffffff;
          background: linear-gradient(315deg, #ce2939 0%, #f08791 100%);
          margin-right: 16px;
        }
        .register {
          color: #ce2939;
          background: #ffffff;
          border: 1px solid #ce2939;
        }
      }
    }
  }
}
</style>
